import { isCdkEnvironment } from 'utils/constants';
import { trackCTAInteractionEvent } from './actions/CTA/interaction';

export function useGTMAnalytics() {
  return {
    trackGTMCTAInteractionEvent: isCdkEnvironment
      ? trackCTAInteractionEvent
      : undefined,
  };
}
